import React, { Component } from 'react'
import ScheduleManager from '../ScheduleManager';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Api from '../../../api/Api.js';
import ReportEndpoints from '../../../api/ReportEndpoints';

class ScheduleTab extends Component {
    render() {

        const { report_id } = this.props;

        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={9} lg={6}>
                    <div style={{ padding: '30px 0', textAlign: 'center' }}>
                        <ScheduleManager innerRef={(scheduler) => this.scheduler = scheduler} />
                        <Button
                            onClick={() => {
                                var newSchedule = this.scheduler.getSchedule();

                                Api.post(ReportEndpoints.changeSchedule, { schedule: newSchedule, report_id })
                                .then(({ data }) => this.props.changedSchedule(data))
                                .catch((e) => console.error(e))
                            }}
                            round 
                            color="primary"
                        >
                            Change Schedule&nbsp;&nbsp;<FontAwesomeIcon icon={faCheckCircle} size="2x" />
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>
        )
    }
}

export default ScheduleTab;